import React, { createContext, useContext, useState, useEffect } from 'react';
import blogService from '../services/blogService';
import projectService from '../services/projectService';

const ContentAvailabilityContext = createContext({
  hasBlogs: true,
  hasCaseStudies: true,
  loading: true,
  refetch: () => {}
});

export const ContentAvailabilityProvider = ({ children }) => {
  const [hasBlogs, setHasBlogs] = useState(true);
  const [hasCaseStudies, setHasCaseStudies] = useState(true);
  const [loading, setLoading] = useState(true);

  const checkAvailability = async () => {
    setLoading(true);
    try {
      // Fetch both counts in parallel
      const [blogCount, projectCount] = await Promise.all([
        blogService.getBlogCount(),
        projectService.getProjectCount()
      ]);

      setHasBlogs(blogCount > 0);
      setHasCaseStudies(projectCount > 0);
    } catch (error) {
      console.error('Error checking content availability:', error);
      // Default to showing content on error to avoid breaking the site
      setHasBlogs(true);
      setHasCaseStudies(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAvailability();
  }, []);

  const value = {
    hasBlogs,
    hasCaseStudies,
    loading,
    refetch: checkAvailability
  };

  return (
    <ContentAvailabilityContext.Provider value={value}>
      {children}
    </ContentAvailabilityContext.Provider>
  );
};

export const useContentAvailability = () => {
  const context = useContext(ContentAvailabilityContext);
  if (!context) {
    throw new Error('useContentAvailability must be used within ContentAvailabilityProvider');
  }
  return context;
};
